const MAP = {
  Draft: "bg-[#F0EFF4] text-[#5C626A] border-[#D4CEBF]",
  Ordered: "bg-[#F0EFF4] text-[#5C626A] border-[#D4CEBF]",
  Received: "bg-[#EBF2EC] text-[#2D5A3C] border-[#B8D7BF]",
  Paid: "bg-[#EBF2EC] text-[#2D5A3C] border-[#B8D7BF]",
  Issued: "bg-[#EEF2F7] text-[#0E1B2E] border-[#C9D3E0]",
  Partial: "bg-[#FEF6E6] text-[#B38E46] border-[#EAD096]",
  Unpaid: "bg-[#FBF0EC] text-[#A3411D] border-[#F2C5B6]",
  Overdue: "bg-[#FBF0EC] text-[#A3411D] border-[#A3411D] font-bold",
  Returned: "bg-[#F0EFF4] text-[#5C626A] border-[#D4CEBF]",
  Void: "bg-[#F0EFF4] text-[#8C929B] border-[#D4CEBF] line-through",
  Cancelled: "bg-[#F0EFF4] text-[#8C929B] border-[#D4CEBF]",
  "Low stock": "bg-[#FEF6E6] text-[#B38E46] border-[#EAD096]",
  "In stock": "bg-[#EBF2EC] text-[#2D5A3C] border-[#B8D7BF]",
  Active: "bg-[#EBF2EC] text-[#2D5A3C] border-[#B8D7BF]",
  Archived: "bg-[#F0EFF4] text-[#8C929B] border-[#D4CEBF]",
  "Out of stock": "bg-[#FBF0EC] text-[#A3411D] border-[#F2C5B6]",
};

export default function StatusChip({ status, className = "" }) {
  const cls = MAP[status] || "bg-[#F0EFF4] text-[#5C626A] border-[#D4CEBF]";
  return (
    <span className={`chip border ${cls} ${className}`} data-testid={`chip-${status}`}>
      {status}
    </span>
  );
}
